import { AuthenticatedUser } from '@blueshift-ui/auth';
import Cookie from 'js-cookie';
import { useMemo } from 'react';

function useActiveLearner(user?: AuthenticatedUser | null) {
  return useMemo(() => {
    if (!user) {
      return undefined;
    }

    const studentUuid = Cookie.get('active_learner_id');
    return user.students?.find((student) => student.uuid === studentUuid);
  }, [user]);
}

export default useActiveLearner;
